export default __webpack_public_path__ + "static/media/carrito_elevador.1e6ea682.png";